var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.225,
    height: 12.225,
    viewBox: "0 0 12.225 12.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter-square",
    "data-name": "Icon awesome-twitter-square",
    d: "M10.915,2.25H1.31A1.31,1.31,0,0,0,0,3.56v9.605a1.31,1.31,0,0,0,1.31,1.31h9.605a1.31,1.31,0,0,0,1.31-1.31V3.56A1.31,1.31,0,0,0,10.915,2.25ZM9.58,6.583c.005.076.005.156.005.232a5.057,5.057,0,0,1-5.092,5.092,5.068,5.068,0,0,1-2.748-.8,3.77,3.77,0,0,0,.431.022A3.588,3.588,0,0,0,4.4,10.362,1.792,1.792,0,0,1,2.726,9.121a1.929,1.929,0,0,0,.808-.033A1.79,1.79,0,0,1,2.1,7.331V7.309a1.788,1.788,0,0,0,.808.226,1.786,1.786,0,0,1-.8-1.49,1.767,1.767,0,0,1,.243-.9A5.081,5.081,0,0,0,6.044,7.014,1.793,1.793,0,0,1,9.1,5.38a3.507,3.507,0,0,0,1.135-.431,1.785,1.785,0,0,1-.786.985,3.561,3.561,0,0,0,1.031-.278A3.767,3.767,0,0,1,9.58,6.583Z",
    transform: "translate(0 -2.25)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.cc75a7ca097d190b45f0ca65a261403b.svg";
export { ForwardRef as ReactComponent };